<template>
	<div class="person-info-form">
		<el-form
			label-position="left"
			label-width="160px"
			:model="ruleForm"
			:rules="rules"
			ref="persionalInfoForm"
		>
			<el-form-item label="姓名" prop="name">
				<el-input v-model="ruleForm.name" class="normal-input"></el-input>
			</el-form-item>
			<el-form-item label="姓名拼音" prop="enName" required>
				<el-row type="flex">
					<el-input
						v-model="ruleForm.enName"
						placeholder="建議威妥瑪(WG)拼音"
						class="normal-input"
					></el-input>
					<a
						href="https://www.boca.gov.tw/sp-natr-singleform-1.html"
						target="_blank"
						class="color-blue1 en-name-link"
						>外交部外文姓名中譯英系統查詢</a
					>
				</el-row>
			</el-form-item>
			<!-- <el-form-item label="性別" prop="gender">
				<el-radio-group v-model="ruleForm.gender" @change="changeRadio">
					<el-radio label="生理男"></el-radio>
					<el-radio label="生理女"></el-radio>
				</el-radio-group>
			</el-form-item> -->
			<el-form-item label="出生年月日" prop="born">
				<el-row type="flex" :gutter="10">
					<el-col>
						<el-date-picker
							v-model="ruleForm.born"
							type="date"
							format="yyyy 年 MM 月 dd 日"
							value-format="timestamp"
							placeholder="出生年月日"
						></el-date-picker>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item label="Email" prop="email">
				<el-input v-model="ruleForm.email" class="email-input"></el-input>
			</el-form-item>
			<el-form-item label="手機" prop="phone">
				<el-input v-model="ruleForm.phone" class="normal-input"></el-input>
			</el-form-item>
			<el-form-item label="學校電話（分機）" prop="tel">
				<el-input v-model="ruleForm.tel" class="normal-input"></el-input>
			</el-form-item>
			<el-form-item label="密碼">
				<div
					class="button-tp change-pwd color-white bg-blue1"
					@click="clickChangePwd"
				>
					更改密碼
				</div>
			</el-form-item>
			<el-form-item label="介紹人">
				<el-input v-model="ruleForm.introducer" class="normal-input"></el-input>
			</el-form-item>

			<el-form-item>
				<div class="row" align-x="right">
					<div class="button-tp color-white bg-text4 button" @click="cancel()">
						取消
					</div>
					<div class="button-tp color-white bg-green1 button" @click="save()">
						儲存
					</div>
				</div>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
	data() {
		return {
			checked: false,
			ruleForm: {
				name: "",
				enName: "",
				// gender: "",
				born: "",
				email: "",
				phone: "",
				tel: "",
				introducer: "",
			},
			rules: {
				name: [{ required: true, message: "請輸入姓名", trigger: "blur" }],
				enName: [
					{
						validator(rule, value, callback) {
							if (!value) callback(new Error("必填"));
							else if (!/^[A-Z][A-Z ]*,([A-Z]*-?){1,2}$/.test(value)) {
								callback(new Error("例：WANG,HSIAO-MING（姓,名-名）"));
							} else callback();
						},
						trigger: "blur",
					},
				],
				// gender: [{ required: true, message: "請選擇性別", trigger: "change" }],
				born: [{ required: true, message: "請選擇出生日期", trigger: "blur" }],
				email: [
					{ required: true, message: "請輸入電子信箱", trigger: "blur" },
					{ type: "email", message: "請輸入正確信箱格式", trigger: "blur" },
				],
				phone: [{ required: true, message: "請輸入聯絡電話", trigger: "blur" }],
			},
		};
	},
	computed: {
		...mapState("user", ["userInfo"]),
		showTeacherOptions() {
			return this.ruleForm.job == "教育工作者";
		},
	},
	methods: {
		...mapActions("user", ["updatePersonBasicProfile"]),
		changeRadio(value) {
			console.log("changeRadio", value);
		},
		save() {
			this.$refs["persionalInfoForm"].validate(async (valid) => {
				if (valid) {
					let data = {
						name: this.ruleForm.name,
						gender: this.ruleForm.gender,
						born_date: this.ruleForm.born,
						phone: this.ruleForm.phone,
						wade_giles: this.ruleForm.enName,
						introducer: this.ruleForm.introducer,
						email: this.ruleForm.email,
						tel: this.ruleForm.tel,
					};
					try {
						await this.updatePersonBasicProfile(data);
						this.$message.success("修改成功");
						this.$emit("cancel");
					} catch (e) {
						this.$message.error("e");
					}
				} else {
					console.log("error");
					return false;
				}
			});
			// console.log("this.ruleForm.born", this.ruleForm.born);
		},
		initializeFormData() {
			this.ruleForm.name = this.userInfo.name;
			this.ruleForm.enName = this.userInfo.wade_giles;
			this.ruleForm.gender = this.userInfo.gender;
			this.ruleForm.born = this.userInfo.born_date;
			this.ruleForm.email = this.userInfo.email;
			this.ruleForm.phone = this.userInfo.phone;
			this.ruleForm.tel = this.userInfo.tel;
			this.ruleForm.introducer = this.userInfo.introducer;
		},
		cancel() {
			this.$emit("cancel");
		},
		clickChangePwd() {
			this.$router.push({ name: "ChangePassword" });
		},
	},
	created() {
		this.initializeFormData();
	},
};
</script>

<style lang="scss" scoped>
.person-info-form {
	.normal-input {
		width: 160px;
	}

	.email-input {
		width: 300px;
	}

	.en-name-link {
		margin-left: 8px;
	}

	.button {
		width: 150px;
		height: 30px;
		margin-left: 10px;
	}

	.change-pwd {
		width: 114px;
		height: 24px;
		margin-top: 6px;
	}
}
</style>
